export const normalizeDownloadCode = (downloadCode: string | null | undefined): string => {
  return (downloadCode || '').replace(/\s+/g, '');
};

export const formatDownloadCode = (downloadCode: string | null | undefined): string => {
  const normalized = normalizeDownloadCode(downloadCode);
  const groups = normalized.match(/.{1,5}/g);
  return groups ? groups.join(' ') : '';
};

export const downloadCodeUrl = (downloadCode: string | null | undefined): string => {
  const normalized = normalizeDownloadCode(downloadCode);
  return normalized ? `https://www.nub.art/nubart/qr/${encodeURIComponent(normalized)}` : '';
};

export default {
  normalizeDownloadCode,
  formatDownloadCode,
  downloadCodeUrl,
};
